// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.notification-shadow {\n    -webkit-box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.5) !important;\n    box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.5) !important;\n}\n", ""]);
// Exports
module.exports = exports;
